import Box from "@mui/material/Box";
import RemoveButton from "./RemoveButton";
import SaveButton from "./SaveButton";

export const getColumns = (
	handleRemove,
	handleUpdate,
	handleCheckboxChange,
	t
) => [
	{
		name: "lp",
		label: "id",
		options: {
			display: "excluded",
		},
	},
	{ label: t("ordinal_number_short"), name: "lp" },
	{
		label: t("company_name_label") + "*",
		name: "company",
		options: {
			customBodyRender: (value, tableMeta, updateValue) => {
				const lp = tableMeta.rowData[0];
				return (
					<input
						key={`company-${lp}`}
						id={`company-${lp}`}
						type="text"
						defaultValue={value}
						placeholder={t("enter_company_name")}
						onBlur={() => {
							const newValue = document.getElementById(`company-${lp}`).value;
							updateValue(newValue);
							handleUpdate(tableMeta.rowIndex, "company", newValue);
						}}
					/>
				);
			},
		},
	},
	{
		label: t("first_name_label"),
		name: "firstname",
		options: {
			customBodyRender: (value, tableMeta, updateValue) => {
				const lp = tableMeta.rowData[0];
				return (
					<input
						style={{ width: "144px" }}
						key={`firstname-${lp}`}
						id={`firstname-${lp}`}
						type="text"
						defaultValue={value}
						placeholder={t("enter_carrier_name")}
						onBlur={() => {
							const newValue = document.getElementById(`firstname-${lp}`).value;
							updateValue(newValue);
							handleUpdate(tableMeta.rowIndex, "firstname", newValue);
						}}
					/>
				);
			},
		},
	},
	{
		label: t("surname_label"),
		name: "lastname",
		options: {
			customBodyRender: (value, tableMeta, updateValue) => {
				const lp = tableMeta.rowData[0];
				return (
					<input
						// style={{ width: "1px" }}
						key={`lastname-${lp}`}
						id={`lastname-${lp}`}
						type="text"
						defaultValue={value}
						placeholder={t("enter_carrier_last_name")}
						onBlur={() => {
							const newValue = document.getElementById(`lastname-${lp}`).value;
							updateValue(newValue);
							handleUpdate(tableMeta.rowIndex, "lastname", newValue);
						}}
					/>
				);
			},
		},
	},
	{
		label: t("nip_label"),
		name: "nip",
		options: {
			customBodyRender: (value, tableMeta, updateValue) => {
				const lp = tableMeta.rowData[0];

				return (
					<input
						style={{ width: "144px" }}
						key={`nip-${lp}`}
						id={`nip-${lp}`}
						type="text"
						defaultValue={value}
						placeholder={t("enter_nip")}
						onBlur={() => {
							const newValue = document.getElementById(`nip-${lp}`).value;
							updateValue(newValue);
							handleUpdate(tableMeta.rowIndex, "nip", newValue);
						}}
					/>
				);
			},
		},
	},
	{
		label: t("email_address_to_send") + "*",
		name: "email",
		options: {
			customBodyRender: (value, tableMeta, updateValue) => {
				const lp = tableMeta.rowData[0];
				return (
					<input
						style={{ width: "140px" }}
						key={`email-${lp}`}
						id={`email-${lp}`}
						type="text"
						defaultValue={value}
						placeholder={t("enter_email_to_send")}
						onBlur={() => {
							const newValue = document.getElementById(`email-${lp}`).value;
							updateValue(newValue);
							handleUpdate(tableMeta.rowIndex, "email", newValue);
						}}
					/>
				);
			},
		},
	},
	{
		label: t("phone_label"),
		name: "phone",
		options: {
			customBodyRender: (value, tableMeta, updateValue) => {
				const lp = tableMeta.rowData[0];
				return (
					<input
						style={{ width: "120px" }}
						key={`phone-${lp}`}
						id={`phone-${lp}`}
						type="text"
						defaultValue={value}
						placeholder={t("enter_phone")}
						onBlur={() => {
							const newValue = document.getElementById(`phone-${lp}`).value;
							updateValue(newValue);
							handleUpdate(tableMeta.rowIndex, "phone", newValue);
						}}
					/>
				);
			},
		},
	},
	{
		label: t("assign_mailing_group"),
		name: "mailingGroups",
		options: {
			customBodyRender: (value, tableMeta, updateValue) => {
				const rowIndex = tableMeta.rowIndex;
				const lp = tableMeta.rowData[0];
				return (
					<Box
						key={`container-group-${rowIndex}-${lp}`}
						sx={{
							display: "flex",
							flexWrap: "wrap",
							justifyContent: "center",
							gap: "12px",
						}}
					>
						{Object.entries(value).map((group, index) => {
							const groupId = group[0];
							const groupName = group[1].name;
							let isChecked = group[1].checked;
							return (
								<div key={`group-${index}-${rowIndex}-${lp}`}>
									<input
										type="checkbox"
										id={`group-${index}-${rowIndex}-${lp}`}
										name={`group-${index}-${rowIndex}-${lp}`}
										defaultChecked={isChecked}
										onChange={(_e) => {
											const newChecked = document.getElementById(
												`group-${index}-${rowIndex}-${lp}`
											).checked;
											updateValue({
												...value,
												[groupId]: {
													...value[groupId],
													checked: newChecked,
												},
											});
											handleCheckboxChange(rowIndex, groupId, newChecked);
										}}
									/>
									<label
										id={`group-${index}-${rowIndex}-${lp}`}
										htmlFor={`group-${index}-${rowIndex}-${lp}`}
									>
										{groupName}
									</label>
								</div>
							);
						})}
					</Box>
				);
			},
		},
	},
	{
		label: t("actions"),
		name: "id",
		options: {
			filter: false,
			sort: false,
			empty: true,
			customBodyRender: (value, tableMeta, _updateValue) => {
				return (
					<Box sx={{ display: "flex", gap: "6px", justifyContent: "center" }}>
						<SaveButton
							rowData={tableMeta.rowData}
							rowIndex={tableMeta.rowIndex}
							handleRemove={handleRemove}
						/>
						<RemoveButton onClick={() => handleRemove(tableMeta.rowIndex)} />
					</Box>
				);
			},
		},
	},
];

export const getOptions = (t) => {
	return {
		rowsPerPage: 100,
		searchOpen: true,
		search: false,
		searchAlwaysOpen: true,
		searchPlaceholder: t("search"),
		filter: false,
		download: true,
		viewColumns: false,
		selectableRows: "multiple",
		print: false,
		textLabels: {
			pagination: {
				next: t("next_page"),
				previous: t("previous_page"),
				rowsPerPage: t("rows_per_page"),
				displayRows: t("of"),
			},
			toolbar: {
				search: t("search"),
				downloadCsv: t("download_csv"),
				print: t("print"),
				viewColumns: t("select_columns"),
				filterTable: t("filters"),
			},
			filter: {
				title: t("filters"),
				reset: t("reset"),
				all: t("all"),
			},
			viewColumns: {
				title: t("show_columns"),
			},
			selectedRows: {
				text: t("removed_rows"),
				delete: t("remove"),
			},
			body: {
				noMatch: t("no_matching_data_found"),
			},
		},
	};
};
